import { useTranslation } from "react-i18next";

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full py-14 md:py-20 px-4 md:px-6 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20fashion%20lifestyle%20background%20with%20soft%20neutral%20beige%20and%20cream%20textures%20featuring%20subtle%20fabric%20folds%20and%20organic%20shapes%20abstract%20composition%20with%20gentle%20gradients%20and%20airy%20negative%20space%20clean%20editorial%20aesthetic%20with%20warm%20natural%20lighting%20and%20peaceful%20atmosphere&width=1600&height=600&seq=pandabuy-cta-bg&orientation=landscape"
        alt="PandabuySpreadsheet Background"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/35"></div>

      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-white mb-3">
          {t("cta.title")}
        </h2>
        <p className="text-sm md:text-base text-white/80 mb-6 md:mb-8">
          {t("cta.subtitle")}
        </p>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 px-8 py-3.5 rounded-lg text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
        >
          {t("cta.button")}
          <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
        </a>
      </div>
    </section>
  );
}